class LeavePageDialog {
    constructor(add) {
        if(add) {
            window.addEventListener('beforeunload', LeavePageDialogListener, {capture: true});
        } else {
            window.removeEventListener('beforeunload', LeavePageDialogListener, {capture: true});
        }
    }
}
window.LeavePageDialog = LeavePageDialog;
window.LeavePageDialogListener = (event) => {
    event.preventDefault();
    return event.returnValue = "Are you sure you want to leave without saving changes?";
};